import { render, staticRenderFns } from "./addteachTree.vue?vue&type=template&id=b639bb54&"
import script from "./addteachTree.vue?vue&type=script&lang=js&"
export * from "./addteachTree.vue?vue&type=script&lang=js&"
import style0 from "./addteachTree.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports